import { cn, Thumbnail, ThumbnailProps } from '@yanolja-rnd/nol-design-system'
import useIsPcWidth from '~/app/utils/useIsPcWidth'

type Props = {
  isDisabled: boolean
  className?: string
} & Omit<ThumbnailProps, 'ratio' | 'shape'> & {
    isDisabled?: boolean
    ratio?: ThumbnailProps['ratio']
    shape?: ThumbnailProps['shape']
  }
/**
 * 공통 > 상품 Thumbnail
 * - NDS Thumbnail + disabled 상태 추가
 * - 지면별로 썸네일의 크기는 다르기 때문에 className으로 설정해야함
 */
const ProductThumbnail = ({
  image,
  isDisabled,
  className,
  /** shape, ratio 는 동일하기 때문에 기본 값 설정함 */
  shape = 'roundedRectangle_8',
  ratio = '3_4',
  ...props
}: Props) => {
  const { isPcWidth } = useIsPcWidth()

  return (
    <Thumbnail
      shape={isPcWidth ? 'roundedRectangle_12' : shape}
      ratio={ratio}
      image={image}
      alt="상품 썸네일 이미지"
      className={cn(
        isDisabled &&
          'after:bg-lightgray after:absolute after:inset-0 after:rounded-8 after:bg-opacityColor-opacity-white-80 after:content-[""]',
        className
      )}
      {...props}
    />
  )
}

export default ProductThumbnail
